import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedProductOptions } from '../../../../../reducers/productConfigSlice';
import ProductOptionFields from './ProductOptionFields';

// The option sets of the product being configured, bound to productConfig.
const ProductOptionsSelector: FC = () => {
  const dispatch = useDispatch();
  const product = useSelector(
    (state: { productConfig: { currentProduct: unknown } }) =>
      state.productConfig.currentProduct,
  );
  const selectedOptions = useSelector(
    (state: {
      productConfig: { selectedProductOptions: Record<string, string> };
    }) => state.productConfig.selectedProductOptions,
  );

  return (
    <ProductOptionFields
      product={product}
      selectedOptions={selectedOptions}
      onChange={(optionSetKey, optionValue) =>
        dispatch(setSelectedProductOptions({ optionSetKey, optionValue }))
      }
    />
  );
};

export default ProductOptionsSelector;
